/**
 * Image downloader for TruTerritory
 */

angular.module("routes:mapping").directive("downloadImage", function () {
  return {
    replace: true,
    scope: {
      truMap: "=",
      map: "=",
      markerId: "=",
    },
    templateUrl: "/truterritory/download-image.html",
    controller: function ($scope, $window, $timeout) {
      $scope.dimensions = { width: null, height: null, zoom: null };
      var map = $scope.truMap.getLeafletMap();

      var boundingBox, lastChanged;

      /**
       * Initialize the box selector
       * @return {void}
       */
      $scope.createBoundingBox = function () {
        boundingBox = new $window.L.AreaSelect({ width: 200, height: 200 });
        boundingBox.addTo(map);
        $scope.dimensions.zoom = $scope.truMap.getZoom();

        $scope.updateDimensions();
        $scope.createOptions();

        $scope.mapSize = map.getSize();

        // Bind the event listeners
        boundingBox.on("change", changeListener);
        boundingBox.on("changing", function () {
          $scope.$apply($scope.updateDimensions);
        });
        map.on("resize", setMapSize);
        map.on("zoom", changeListener);
      };

      // On destroy, make sure everything gets cleaned up
      $scope.$on("$destroy", function () {
        if (boundingBox) {
          boundingBox.off("change", changeListener);
          boundingBox.off("changing", $scope.updateDimensions);
        }
        map.off("resize", setMapSize);
        map.off("zoom", changeListener);
      });

      // Fired on map resize
      function setMapSize(event) {
        $scope.mapSize = event.newSize;
      }

      /**
       * Listens to changes from the bounding box
       * @param  {object} event
       * @return {void}
       */
      function changeListener(event) {
        // If there's a previous event, this means that the user initiated the change,
        //  If not, return, b/c updating the UI will cause the inputs to be rounded, causing weeeeeird stuff to happen,
        //  like not being able to increment the inputs by less than 2
        if (!event.prevEvent) return;

        $scope.updateDimensions();
        $scope.createOptions();
      }

      /**
       * Updates the dimensions inputs
       * @return {void}
       */
      $scope.updateDimensions = function () {
        var size = getBoxSize();
        $scope.dimensions.width = size.width;
        $scope.dimensions.height = size.height;
      };

      /**
       * Fired when the user inputs a width or height;
       *   Sets the box size and updates the select options
       * @param  {integer} width
       * @param  {integer} height
       * @return {void}
       */
      $scope.changeSize = function (width, height) {
        boundingBox.setDimensions({ width: width, height: height });
        $scope.createOptions();
      };

      /**
       * Create the magnification options
       * @param  {object|null} event
       * @return {void}
       */
      $scope.createOptions = function (event) {
        // Reset the sizes and get the current zoom
        $scope.sizes = [];
        var currentZoom = $scope.truMap.getZoom();

        // Loop through all valid zoom levels (1-20)
        for (var i = 1; i <= 20; i++) {
          var size = Math.pow(2, i - currentZoom);

          // If the dimensions are too big or too small, don't add it
          if ($scope.dimensions.width * size >= 16384 || $scope.dimensions.height * size >= 16384 || $scope.dimensions.width * size <= 16 || $scope.dimensions.height * size <= 16)
            continue;

          $scope.sizes.push({ value: i, name: size + "x" });
        }

        // If the current user-selected zoom isn't available anymore, set it to the current zoom
        if (!_.find($scope.sizes, { value: $scope.dimensions.zoom })) $scope.dimensions.zoom = currentZoom;
      };

      /**
       * Gets the size of the bounding box
       * @return {object} {width: integer, height: integer}
       */
      function getBoxSize() {
        var bounds = boundingBox.getBounds();

        var ne = $scope.truMap.getLeafletMap().latLngToLayerPoint(bounds.getNorthEast());
        var sw = $scope.truMap.getLeafletMap().latLngToLayerPoint(bounds.getSouthWest());

        var width = ne.x - sw.x;
        var height = sw.y - ne.y;

        return { width: width, height: height };
      }

      /**
       * Actually download the image by opening a link
       * @return {void}
       */
      $scope.downloadImage = function () {
        var bounds = boundingBox.getBounds();
        const marker = $scope.markerId && $scope.truMap._layers[$scope.markerId] && $scope.truMap._layers[$scope.markerId].getLatLng()
        $window.open($scope.map.getImageDownloadUrl($scope.dimensions.zoom, bounds.getSouthWest(), bounds.getNorthEast(), marker && [marker.lng, marker.lat]));
      };

      /**
       * Close everything down!
       * @return {void}
       */
      $scope.close = function () {
        boundingBox.remove();
      };
    },
  };
});
